/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Undo_ApproveInputs */

const en_samples_undo_approve = /** @type {(inputs: Samples_Undo_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo Approve`)
};

const es_samples_undo_approve = /** @type {(inputs: Samples_Undo_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshacer aprobacion`)
};

/**
* | output |
* | --- |
* | "Undo Approve" |
*
* @param {Samples_Undo_ApproveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_undo_approve = /** @type {((inputs?: Samples_Undo_ApproveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Undo_ApproveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_undo_approve(inputs)
	return es_samples_undo_approve(inputs)
});